import { createContext } from 'react';

const deckContext = createContext();

export default deckContext;
